import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const ReloadIcon = ({
  className,
  style,
  color = '#fff',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        // tslint:disable-next-line: max-line-length
        d="M13.2047 2.27031L12.3234 2.95937C11.1219 1.42344 9.25313 0.4375 7.15469 0.4375C3.53126 0.4375 0.598443 3.36719 0.593756 6.99219C0.589068 10.6203 3.52813 13.5625 7.15469 13.5625C9.98751 13.5625 12.4016 11.7656 13.3203 9.24844C13.3438 9.18281 13.3094 9.10937 13.2438 9.0875L12.3578 8.78281C12.3269 8.77222 12.2931 8.77414 12.2636 8.78816C12.2341 8.80218 12.2113 8.82718 12.2 8.85781C12.1719 8.93594 12.1406 9.01406 12.1078 9.09062C11.8375 9.73125 11.45 10.3063 10.9563 10.8C10.4665 11.2907 9.88661 11.6822 9.24844 11.9531C8.58751 12.2328 7.88282 12.375 7.15782 12.375C6.43126 12.375 5.72813 12.2328 5.06719 11.9531C4.4284 11.6834 3.84832 11.2917 3.35938 10.8C2.86829 10.3103 2.47717 9.72971 2.20782 9.09062C1.92813 8.42812 1.78594 7.725 1.78594 6.99844C1.78594 6.27187 1.92813 5.56875 2.20782 4.90625C2.47813 4.26562 2.86563 3.69063 3.35938 3.19688C3.85313 2.70313 4.42813 2.31563 5.06719 2.04375C5.72813 1.76406 6.43282 1.62188 7.15782 1.62188C7.88438 1.62188 8.58751 1.76406 9.24844 2.04375C9.88723 2.31351 10.4673 2.70519 10.9563 3.19688C11.1109 3.35156 11.2563 3.51562 11.3906 3.6875L10.45 4.42188C10.4314 4.43627 10.4172 4.45563 10.4091 4.47772C10.401 4.49981 10.3993 4.52374 10.4042 4.54676C10.4091 4.56977 10.4204 4.59094 10.4368 4.60782C10.4532 4.6247 10.474 4.63661 10.4969 4.64219L13.2406 5.31406C13.3188 5.33281 13.3953 5.27344 13.3953 5.19375L13.4078 2.36719C13.4063 2.26406 13.2859 2.20625 13.2047 2.27031V2.27031Z"
        fill={color}
      />
    </svg>
  );
};
